import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=4c1fe596&scoped=true"
import script from "./UserSettings.vue?vue&type=script&lang=js"
export * from "./UserSettings.vue?vue&type=script&lang=js"
import style0 from "./UserSettings.vue?vue&type=style&index=0&id=4c1fe596&prod&scoped=true&lang=css"
import style1 from "./UserSettings.vue?vue&type=style&index=1&id=4c1fe596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1fe596",
  null
  
)

export default component.exports